import axios from 'axios'

export const validateMaxLines = async (body: any) => {
  const preactivacionURL = '/preactivation/valida-maxima-lineas'
  try {
    const response = await axios.post(preactivacionURL, body, { headers: { 'Content-Type': 'application/json' } })
    return response
  } catch (e) {
    if (axios.isAxiosError(e) && e.response) {
      return e.response
    }
    throw e
  }
}
